import { render, staticRenderFns } from "./RequiredLogin.vue?vue&type=template&id=0c70d5be&"
import script from "./RequiredLogin.vue?vue&type=script&lang=js&"
export * from "./RequiredLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports